import React from 'react';

import { ThemeProvider } from 'emotion-theming';

const Tint = ({ color, children }) => (
  <ThemeProvider
    theme={{
      tintColor: color,
    }}
  >
    {children}
  </ThemeProvider>
);

export default Tint;
